import React from "react";
import AuthLayout from "./AuthLayout";
import MarketingFooter from "./MarketingFooter";
import { SessionField, SubmitButton } from "./AuthFields";
import ActionLink from "./ActionLink";

const PhoneNumberFormPage = ({
  action,
  showSendToEmail,
  sendToEmailPath,
  verificationCodeFormPath,
  logoutPath
}) => (
  <AuthLayout
    action={action}
    formClassName="login-form"
    autoComplete="off"
    formInnerStyle={{ marginTop: "30px" }}
    headerText="Please enter your phone number:"
    footer={
      <>
        <ul>
          {showSendToEmail && (
            <li>
              <ActionLink
                action={sendToEmailPath}
                nextPath={verificationCodeFormPath}
                className="logout"
              >
                Send Verification Code To Email
              </ActionLink>
            </li>
          )}
          <li>
            <a href={logoutPath} className="logout">
              Logout
            </a>
          </li>
        </ul>
        <MarketingFooter />
      </>
    }
  >
    <SessionField type="tel" name="phone_number[main]" id="country-phone" autoFocus />
    <div className="mtm">
      <SubmitButton value="Send Verification Code" id="submit-btn" style={{ width: "210px" }} />
    </div>
  </AuthLayout>
);

export default PhoneNumberFormPage;
